import axios from "@/http/api";
import url from "@/interface/url";
import methods from "./method";
const request = (url, method, data) => {
  if (!data) {
    data = {};
  }
  if (url == "setting/getDefault") {
    let hostname = window.location.hostname;
    if (hostname != "localhost" && hostname != "10.0.0.160") {
      let hostnameset = hostname.split(".");
      let loginUrl = hostnameset[0] ? hostnameset[0] : "";
      // let loginUrl = "control";
      if (loginUrl) {
        data["loginUrl"] = loginUrl;
      } else {
        data["uId"] = 1;
      }
    } else {
      data["uId"] = 1;
    }
  }
  if (method && method === methods.get) {
    return axios({
      url: url,
      method: method,
      params: data
    });
  }
  return axios({
    url: url,
    method: method,
    data: data || {}
  });
};
const download = (url, data) => {
  return axios({
    url: url,
    method: methods.post,
    data: data,
    responseType: "blob"
  }).then(res => {
    // 从响应头中获取文件名
    let fileName = "download";
    const contentDisposition = res.headers["content-disposition"];
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1].replace(/['"]/g, "");
        // 处理URL编码的文件名
        try {
          fileName = decodeURIComponent(fileName);
        } catch (e) {
          console.warn("无法解码文件名:", fileName);
        }
      }
    }

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(
      new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      })
    );
    link.target = "_blank";
    link.download = fileName; // 设置从后端获取的文件名
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href); // 释放URL 对象
    document.body.removeChild(link);
  });
};
const upload = (url, data) => {
  return axios({
    url: url,
    method: methods.post,
    data: data,
    headers: { "Content-Type": "multipart/form-data" }
  });
};
//字典
const dict = data => {
  return axios({
    url: url.DictData.listDictData,
    method: methods.get,
    params: { type: data }
  });
};
export default { request, dict, download, upload };
